import { DateTimePipe } from 'src/app/shared/pipes/date-time.pipe';

export const mapOptions = {
  disableDefaultUI: false,
  clickableIcons: false,
  disableDoubleClickZoom: false,
  fullscreenControl: false,
  mapTypeId: 'roadmap',
  streetViewControl: false,
  scrollwheel: true,
  zoomControl: true,
  center: { lat: 20.5937, lng: 78.9629 },
  zoom: 4.7,
  cameraControl: false,
  mapTypeControl: false,
  mapId: '447905a36a200a99',
};

export function statusColor(status: any) {
  let statusWiseColor: any = '';
  switch (status) {
    case 'Moving':
      statusWiseColor = '#1FBE62';
      break;
    case 'Stop':
      statusWiseColor = '#CF1945';
      break;
    case 'Charging':
      statusWiseColor = '#0892D0';
      break;
    case 'Offline':
      statusWiseColor = '#505050';
      break;
    case 'Breakdown':
      statusWiseColor = '#E74C3C';
      break;
    case 'Accident':
      statusWiseColor = '#FF8C00';
      break;
    case 'Idle':
      statusWiseColor = '#9B59B6';
      break;
    case 'PTO':
      statusWiseColor = '#154F55';
      break;
    case 'Service':
      statusWiseColor = '#ff6982';
      break;
    default:
      statusWiseColor = '#1FBE62';
  }
  return statusWiseColor;
}

export function batteryColor(battery: any) {
  let color: any = battery / 10;
  if (battery < 3) {
    color = '#CF1945';
  } else if (battery == 3) {
    color = '#FF9900';
  } else if (battery > 3) {
    color = '#1FBE62';
  }

  return color;
}

export function infoWindow(vehicleColor: any, data: any, batteryColor: any) {
  let odometer = '0';
  if (data?.vehicleTypeCode === 'VC02') {
    data['unit'] = 'Hrs';
    odometer =
      data?.hourmeter !== undefined
        ? `${data?.hourmeter} ${data?.unit ?? 'Hrs'}`
        : '';
  } else {
    odometer =
      data?.odometer !== undefined
        ? `${data?.odometer} ${data?.unit ?? 'km'}`
        : '';
  }

  const soc: number = data?.soc / 10;
  const speed = data?.speed !== undefined ? `${data?.speed} km/h` : '-';
  const geo_lat = data?.geo_lat ? parseFloat((+data?.geo_lat).toFixed(6)) : '-';
  const geo_long = data?.geo_long
    ? parseFloat((+data?.geo_long).toFixed(6))
    : '-';
  const latLng = `${geo_lat}, ${geo_long}`;

  const address = data?.address == 'latlng' ? latLng : data?.address;
  const meterLable = data?.unit == 'Hrs' ? 'Hour Meter' : 'Odometer';
  let hourMeter = '-';

  if (data?.variantCode === 'VC011') {
    hourMeter =
      data?.hourmeter !== undefined && data?.hourmeter !== null
        ? `${data?.hourmeter} Hrs`
        : '-';
  }
  const dateTimePipe = new DateTimePipe();
  const dateValue = data?.last_updated_time;
  const lastConnectedFormat =
    dateTimePipe.transform(dateValue, 'dateTime') ?? '-';

  let contentString =
    `
  <div style="width: 100%; height: 100%; min-height: 255px; display: flex; flex-direction: column; align-items: flex-start;">
  <div style="height: 40px; background: ` +
    vehicleColor +
    `; padding: 4px 11px; border-top-left-radius: 8px; border-top-right-radius: 8px; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px;">
      <div style="width: 220px; display: flex; justify-content: flex-start; align-items: center; gap: 174px;">
          <div style="display: flex; gap: 100px;">
              <div style="display: flex; justify-content: center; align-items: center;">
                  <div>
                      <span style="color: white; font-size: 11px; font-family: Inter; font-weight: 400; line-height: 16px; word-wrap: break-word;">Vehicle No</span><br>
                      <span style="color: white; font-size: 11px; font-family: Inter; font-weight: 600; line-height: 16px; word-wrap: break-word;">` +
    data.vehicle_number +
    `</span>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div style="width: 223px; height: 138.25px; position: relative;">
      <div style="position: absolute; width: 100%; height: 100%;">
          <div ></div>
          <div style="position: absolute; width: 23.38px; height: 20.25px; left: 100px; top: 138.25px; background: white;"></div>
      </div>
      <div style="position: absolute; width: 230px; height: 97px; left: 10px; top: 10px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 11px;">
          <div style="display: flex;">
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;width: 160px">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">Last Connected</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-wrap: break-word;">  ${lastConnectedFormat}` +
    `</div>
              </div>
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400;">Status</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-wrap: break-word;">` +
    data.status +
    `</div>
              </div>
          </div>
          <div style="display: flex">
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;width: 160px">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">` +
    meterLable +
    `</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; white-space: nowrap;">` +
    odometer +
    `</div>
              </div>
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">Speed</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; white-space: nowrap;">` +
    speed +
    `</div>
              </div>
          </div>
          ${
            data?.variantCode === 'VC011'
              ? `
      <div style="display: flex;">
          <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;">
              <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400;">
                  Hour Meter
              </div>
              <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; white-space: nowrap;">
                  ${hourMeter}
              </div>
          </div>
      </div>
    `
              : ''
          }
          <div style="display: flex; gap: 30px;">
              <div style="display: flex; justify-content: flex-start; align-items: center; gap: 5px;">
                  <div style="position: relative; width: 83px; height: 18px;">
                      <div style="position: absolute; width: 100%; height: 100%; background: rgba(217, 217, 217, 0.05); border-radius: 4px; border: 0.7px #9F9F9F solid;"></div>
                      <div style="position: absolute; width: ` +
    soc * 8 +
    `; height: 14px; display: flex; justify-content: flex-start; align-items: flex-start; gap: 0.5px;margin-left:1px">
  `;

  let str = '';
  for (let index = 0; index < soc; index++) {
    let borderradius;
    if (index == 0) {
      borderradius = '3px 0 0 3px';
    } else if (index == 9) {
      borderradius = '0 3px 3px 0';
    }
    str =
      str +
      `<div style="width: 7px; height: 14px; background: ` +
      batteryColor +
      `; border-radius: ` +
      borderradius +
      `;
  margin-top: 2px;margin-left:0.5px"></div>`;
  }

  const xyz =
    `
                      </div>
                  </div>
                  <div style="display: flex; gap: 72px;">
                      <div style="color: ` +
    batteryColor +
    `; font-size: 8px; font-family: Inter; font-weight: 600; word-wrap: break-word;">` +
    soc * 10 +
    `% (SOC)</div>
                  </div>
              </div>
          </div>
          <div style="display: flex; gap: 120px;">
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px;">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">Address</div>
                  <div  id="appLocationContainer"  style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-wrap: break-word;">
                  </div>
              </div>
          </div>
      </div>
  </div>
  </div>
  `;

  contentString = contentString + str + xyz;
  return contentString;
}

export const livetrackingfilter = {
  vehicleSingle: true,
};

export function getAddress(lat: any, lng: any): Promise<string> {
  return new Promise((resolve, reject) => {
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat, lng };

    geocoder.geocode({ location: latlng }, (results: any, status) => {
      if (status === 'OK' && results[0]) {
        resolve(results[0].formatted_address);
      } else {
        resolve('No address found');
      }
    });
  });
}
